import { Form, Select, Tooltip, Typography } from "antd";
import { useSelector } from "react-redux";
import { IAutomaticAction } from "@components/Settings/AutomaticActions/consts";
import { LockedGroupLabel } from "@components/PermissionedComponents/lockedStreamGroups";

const { Text } = Typography;

const SLICER_LOCKED_MESSAGE = "A dashboard with a slicer cannot be sent as a report.";

interface ISandboxDashboard {
    id: string;
    name: string | null;
    info?: { widgets?: { type: string }[] } | null;
}

const hasSlicer = (dashboard: ISandboxDashboard) =>
    (dashboard.info?.widgets ?? []).some((widget) => widget.type === "slicer");

export const toDashboardReportFormValues = (metadata: IAutomaticAction['metadata']) => ({
    dashboard_id: metadata?.dashboard_id,
});

export const toDashboardReportMetadata = (values: any) => ({
    dashboard_id: values.dashboard_id,
    emails: values.emails,
});

export const DashboardReportFields = ({ disabled }: { disabled: boolean }) => {
    const dashboards = useSelector(({ team }: any) => team.sandboxDashboards) as ISandboxDashboard[];

    // Available dashboards sort ahead of locked ones. Ties keep the API order (stable sort).
    const options = (dashboards ?? [])
        .map((d) => ({ dashboard: d, locked: hasSlicer(d), name: d.name || 'Untitled dashboard' }))
        .sort((a, b) => Number(a.locked) - Number(b.locked))
        .map(({ dashboard, locked, name }) => ({
            value: dashboard.id,
            name,
            disabled: locked,
            label: locked ? (
                <Tooltip title={SLICER_LOCKED_MESSAGE} placement="right">
                    <span><LockedGroupLabel label={name} /></span>
                </Tooltip>
            ) : name,
        }));

    return (
        <Form.Item
            label={<Text>Dashboard</Text>}
            name="dashboard_id"
            extra="The PDF uses the permissions of the coach who created this action."
            rules={[{ required: true, message: 'Please select a dashboard.' }]}
        >
            <Select
                showSearch
                optionFilterProp="name"
                options={options}
                placeholder="Select a sandbox dashboard"
                notFoundContent={<Text type="secondary">No sandbox dashboards found.</Text>}
                disabled={disabled}
            />
        </Form.Item>
    );
};

export default DashboardReportFields;
